import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Importation des polices
import '@fontsource/great-vibes';
import '@fontsource/playfair-display';
import '@fontsource/lato';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
